import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { parameterizePath } from '@/lib/analyticsSanitization';
import { trackOpenPanelView } from '@/lib/openpanel';

/** Report each route after clinician identity has hydrated. */
export const useOpenPanelViews = (clinicianId?: number | null): void => {
  const { pathname } = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (clinicianId != null && lastPathRef.current !== pathname) {
      lastPathRef.current = pathname;
      trackOpenPanelView(parameterizePath(pathname));
    }
  }, [pathname, clinicianId]);
};
